import styled from "styled-components";

const CardImage = styled.div`
  position: relative;
  max-width: ${(props) => (props.grid ? "100%" : "220px")};
  width: ${(props) => (props.grid ? "100%" : "70%")};
  height: ${(props) => (props.grid ? "200px" : "110px")};
  background-image: ${(props) => `url("${props.img}")`};
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 8px;
  object-fit: cover;
  color: ${({ theme }) => theme.colors.white};
  div {
    opacity: 0;
  }
  padding: 10px;
  // border-radius: 8px 8px 0px 0px;
  div {
    opacity: 1;
    cursor: pointer;
  }
  &:hover {
    background-image: ${(props) =>
      props.grid
        ? `linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.1) 0%,
        rgba(0, 0, 0, 0.4) 50%,
        rgba(0, 0, 0, 0.9) 100%
      ), url("${props.img}")`
        : ""};
  }
`;

const CardContent = styled.div`
  width: 100%;
`;

const Content = styled.div`
  width: 100%;
  padding: 10px;
  align-self: ${(props) => (props.grid ? "initial" : "center")};
  height: ${(props) => (!props.grid ? "100% !important" : "fit-content")};
`;

const CardContainer = styled.div`
  position: relative;
  width: 100%;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    /* background-color: ${({ theme }) => theme.colors.white}; */
    /* div {
      border-radius: ${(props) =>
      props.grid ? "8px 8px 0px 0px" : "8px 0px 0px 8px"};
    } */
  }
`;

export { CardImage, Content, CardContent, CardContainer };
